import { z } from 'zod';
import { licenseSchema } from '@/models/licenseSchema';
import { annotationSchema } from '@/models/annotationSchema';
import { organism } from './organism';
import { overviewImageView } from './overviewImageView';
import { projectStatus } from './projectStatus';

export const projectSchema = z.object({
  id: z.number().int().nonnegative(),
  version: z.string(),
  disease: annotationSchema.nullable(),
  diseaseName: z.string().nullable(),
  organism: organism.nullable(),
  organismName: z.string().nullable(),
  status: projectStatus,
  directory: z.string(),
  progress: z.number(),
  notifyEmail: z.string(),
  logEntries: z.boolean(),
  name: z.string(),
  sharedInMinervaNet: z.boolean(),
  owner: z.object({
    id: z.number(),
  }),
  projectId: z.string(),
  creationDate: z.string(),
  overviewImageViews: z.array(overviewImageView),
  topOverviewImage: overviewImageView.nullable(),
  license: z.optional(licenseSchema).nullable(),
  customLicenseName: z.string().nullable(),
  customLicenseUrl: z.string().nullable(),
  topMap: z.object({
    id: z.number().int().nonnegative().nullable(),
  }),
  sbgnFormat: z.boolean(),
  networkViewAsDefault: z.boolean(),
  hideElementsOnZoomInFrontend: z.boolean(),
  readonly: z.boolean(),
  sourceGitRepository: z.string().nullable(),
  sourceGitBranch: z.string().nullable(),
});
